import { useEffect } from "react";
import Options from "./Options";
import Answers from "./Answers";

function Question({
  question,
  answer,
  dispatch,
  index,
  numQuestions,
  remainingSeconds,
}) {
  useEffect(
    function () {
      const id = setInterval(function () {
        dispatch({ type: "timerTick" });
      }, 1000);

      return function () {
        clearInterval(id);
      };
    },
    [dispatch]
  );

  return (
    <>
      <h4> {question.question}</h4>

      <Options question={question} dispatch={dispatch} answer={answer} />
      <Answers
        answer={answer}
        correctOption={question.correctOption}
        dispatch={dispatch}
        question={question}
      />
    </>
  );
}

export default Question;
